import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import { isValid, parse } from "date-fns";

export const schema = Yup.object().shape({
NomeFilho: Yup.string()
  .matches(
    /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+(?: [a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð'-]+)+$/u,
    MESSAGE.invalidName
  )
  .required(MESSAGE.requiredField),
DataNascimentoFilho: Yup.mixed()
  .required(MESSAGE.requiredField)
  .test({
    name: "birthDate",
    message: MESSAGE.invalidDate,
    test: (value) =>
      value &&
      isValid(parse(value, "dd/MM/yyyy", new Date())) &&
      parse(value, "dd/MM/yyyy", new Date()) >= new Date("01/01/1900"),
  })
  .test({
    name: "birthDate",
    message: MESSAGE.legallyOlder3Years,
    test: (value) => {
      if (!value) return false;
      
      const [day, month, year] = value.split('/').map(Number);
      const birthDate = new Date(year, month - 1, day);

      if (isNaN(birthDate.getTime())) {
        return false;
      }

      const currentDate = new Date();
      const threeYearsAgo = new Date();
      threeYearsAgo.setFullYear(currentDate.getFullYear() - 3);

      birthDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
      threeYearsAgo.setHours(0, 0, 0, 0);

      return birthDate >= threeYearsAgo && birthDate <= currentDate;
     
    }
  }),
});